import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { ScrollToTop } from "@/components/ScrollToTop";
import PasswordGate from "@/components/PasswordGate";
import Home from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import About from "@/pages/About";
import OurStory from "@/pages/OurStory";
import InsideLifely from "@/pages/InsideLifely";
import Pricing from "@/pages/Pricing";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Upgrade from "@/pages/Upgrade";

// Google Analytics page view tracking for SPA
function usePageTracking() {
  const location = useLocation();
  
  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'G-5BFPBLVG2H', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);
}

function AppContent() {
  usePageTracking();
  
  return (
    <div className="App grain-overlay">
      <ScrollToTop />
      <Header />
      <main className="min-h-screen">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/about" element={<About />} />
          <Route path="/our-story" element={<OurStory />} />
          <Route path="/inside-lifely" element={<InsideLifely />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms-of-service" element={<Terms />} />
          <Route path="/upgrade" element={<Upgrade />} />
        </Routes>
      </main>
      <Footer />
      <Toaster richColors position="bottom-right" />
    </div>
  );
}

function App() {
  return (
    <PasswordGate>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </PasswordGate>
  );
}

export default App;
